/*******************************************************************************
 * Project：
 * Summary:
 *　　 Define selectbox component directive
 * Remarks:
 *     selectbox component
 * History：
 *      NghiaNX            2021/04/26    Create
 ******************************************************************************/
import { Component, Input, Output, EventEmitter, OnInit, ViewChild, OnChanges, SimpleChanges } from '@angular/core';
import { Utility } from '../../utility/utility';

@Component({
  selector: 'app-select-box',
  templateUrl: './select-box.component.html',
  styleUrls: ['./select-box.component.scss']
})
export class SelectBoxComponent implements OnInit, OnChanges {
  @Output() oSelectValue = new EventEmitter();
  @Input() public ngModelSelect: string;
  @Input() public items: any[];
  @Input() public hasError: boolean;
  @Input() public disabled: boolean;
  @Input() public showDef: boolean;
  public textFocus: string;
  public textDefault: string;
  public flagSelect: boolean;
  @ViewChild('ngselect', { static: false }) ngselect: any;

  constructor(public utility: Utility) { }

  ngOnInit(): void {
    if (!this.utility.isNullOrBlank(this.items) && this.items.length > 0) {
      this.ngModelSelect = this.items[0].value;
    }
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (this.utility.isNullOrBlank(changes.ngModelSelect) && !changes.ngModelSelect.firstChange) {
      this.changeSelect();
    }
  }
  changeSelect() {
    this.flagSelect = true;
    this.oSelectValue.emit(this.ngModelSelect);
  }
  focusInputField() {
    this.flagSelect = false;
    this.textFocus = !this.utility.isNullOrEmpty(this.ngModelSelect) ? JSON.parse(JSON.stringify(this.ngModelSelect)) : '';
    this.ngModelSelect = '';
  }
  onCloseDropdown() {
    this.ngModelSelect = this.textFocus;
  }
  addSelectedItem() {
    this.ngselect.searchInput.nativeElement.blur();
  }
  SearchInputField() {
    const valueSearch = this.ngselect.searchInput.nativeElement.value;
    const check = this.items.find((el: any) => {
      return el.text.indexOf(valueSearch) > -1;
    });
    if (check === undefined) {
      $('.ng-dropdown-panel').hide();
    } else {
      $('.ng-dropdown-panel').show();
    }
  }
}
